import React from 'react';

/**
 * KPI del sistema: tarjeta de color sólido con texto blanco, etiqueta arriba, número grande,
 * subtítulo opcional y el ícono grande translúcido a la derecha. Una sola receta para toda la app
 * (sin degradados); el color sale de `tono`.
 *
 * @param {string} label    Qué mide (ej. "Total trámites").
 * @param {node}   valor    El número (o texto corto si esTexto).
 * @param {string} [sub]    Contexto (ej. "32% del total").
 * @param {string} [icono]  Clase de Bootstrap Icons sin el prefijo "bi-" (ej. "folder2-open").
 * @param {string} [tono]   area (default) | primario | rti | art | recepcion | cobranzas | anses | admin | exito | advertencia | peligro | neutro.
 * @param {bool}   [esTexto] El valor es un nombre, no un número (se muestra más chico).
 * @param {func}   [onClick] Si se pasa, la tarjeta es un botón navegable.
 */
export default function TarjetaKpi({ label, valor, sub, icono, tono, esTexto = false, onClick }) {
    const clase = `ds-kpi${tono ? ` ds-kpi--${tono}` : ''}`;
    const contenido = (
        <>
            {icono && (
                <span className="ds-kpi__icono" aria-hidden="true">
                    <i className={`bi bi-${icono}`} />
                </span>
            )}
            <span className="ds-kpi__cuerpo">
                <span className="ds-kpi__label d-block">{label}</span>
                <span className={`ds-kpi__valor d-block${esTexto ? ' ds-kpi__valor--texto' : ''}`}>{valor}</span>
                {sub && <span className="ds-kpi__sub d-block">{sub}</span>}
            </span>
        </>
    );
    if (onClick) {
        return <button type="button" className={clase} onClick={onClick}>{contenido}</button>;
    }
    return <div className={clase}>{contenido}</div>;
}
